import React, { useState } from "react";
import { Box, Stack, Button, Typography } from "@mui/material";
import { AppColors } from "../../../../utils/colors";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import LoadingGif from "./../../../../assets/images/multi_file_upload_loading.gif";
import SuccessUploadGif from "./../../../../assets/images/success_upload.gif";
import { isArrayEmpty, isNull, isUndefined } from "../../../../utils/utils";
import PatientsInformationTable from "../../../../components/PatientsInformationTable/PatientsInformationTable";
import CustomUploadButton from "../../../../components/uploadButton";
import DecisionModal from "../../../../components/decisionModal";
import { recordFieldMapping } from "../../../../utils/constants";
import { STORAGE_KEYS, getDataLocally } from "../../../../utils/localStorage";

const StaticUploadMultipleSection = ({ fieldMapping = recordFieldMapping, submitBulkFn, acceptTypes = ".csv" }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [isUploading, setUploading] = useState(false);
  const [selectedFile, setSelectedFile] = useState();
  const [uploadedRecords, setUploadedRecords] = useState([]);
  const getLoggedInOrganization = getDataLocally(STORAGE_KEYS.LOGIN_ORGANIZATION);

  const toggleUploadModal = () => setModalOpen(!modalOpen);

  const handleDrop = (event) => {
    event.stopPropagation();
    event.preventDefault();
    event.currentTarget.style.backgroundColor = AppColors.grey.main;
    const droppedFile = event.dataTransfer.files[0];
    if (!isUndefined(droppedFile)) {
      setSelectedFile(droppedFile);
      setModalOpen(true);
      fileUploadService(droppedFile);
    }
  };

  const handleFileUpload = (e) => {
    if (!isUndefined(e.target.files[0])) {
      const file = e.target.files[0];
      setSelectedFile(file);
      setModalOpen(true);
      fileUploadService(file);
    }
  };

  async function fileUploadService(file) {
    setUploading(true);
    const formData = new FormData();
    formData.append('record_file', file);
    formData.append('org_id', getLoggedInOrganization.org_id);
    formData.append('user_id', getLoggedInOrganization.user_id);
    if (submitBulkFn) {
      await submitBulkFn(formData).then((res) => {
        setUploadedRecords(res.body.data);
        setUploading(false);
      });
    } else {
      console.log('Bulk upload file:', file.name);
      console.log('org_id:', getLoggedInOrganization.org_id, 'user_id:', getLoggedInOrganization.user_id);
    }
  }

  return (
    <>
      <Box onDragOver={handleDrop} onDrop={handleDrop} sx={{ backgroundColor: "white", border: `1px dashed ${AppColors.grey.main}`, borderRadius: "10px" }}>
        {isArrayEmpty(uploadedRecords) ? (
          <Stack direction="column" justifyContent="center" alignItems="center" sx={{ backgroundColor: AppColors.grey.light, borderRadius: "inherit", border: `1px dashed ${AppColors.grey.main}`, padding: 5 }}>
            <UploadFileIcon style={{ fontSize: "50" }} />
            <Typography color={AppColors.grey.medium} fontWeight={600} fontSize={18}>Drag and Drop Files Here</Typography>
            <Typography color={AppColors.grey.medium} fontSize={18}>OR</Typography>
            <Button component="label" color="secondary" variant="text" sx={{ fontWeight: 600 }} role={undefined} tabIndex={-1}>
              Browse
              <input type="file" hidden accept={acceptTypes} onChange={handleFileUpload} />
            </Button>
            <Typography color={AppColors.appColor.main} fontSize={14} fontStyle="italic">Supported Format: {acceptTypes.split(',').join(', ').toUpperCase()}</Typography>
          </Stack>
        ) : (
          <RecordsView data={uploadedRecords} onFileUpload={handleFileUpload} fieldMapping={fieldMapping} acceptTypes={acceptTypes} />
        )}
      </Box>
      <DecisionModal
        showModal={modalOpen}
        title={isUploading ? 'Uploading...' : 'Successfully Uploaded'}
        message={isUploading ? !isUndefined(selectedFile) && selectedFile.name : 'Total No. of Records: ' + uploadedRecords.length}
        icon={isUploading ? LoadingGif : SuccessUploadGif}
        handleModalState={toggleUploadModal}
      />
    </>
  );
};

const RecordsView = ({ data, onFileUpload, fieldMapping, acceptTypes }) => {
  return (
    <Stack>
      {!isUndefined(data) && !isNull(data) && <PatientsInformationTable patientData={data} fieldMapping={fieldMapping} />}
      <CustomUploadButton name="Upload" color="primary" acceptTypes={acceptTypes} handleFileUpload={onFileUpload} />
    </Stack>
  );
};

export default StaticUploadMultipleSection;
